<template>
    <div>
        <div class="search-container primary mb10 mt10">
            <div class="form-box">
                <input class="input-field" v-model="name" placeholder="请输入服务商名称"/>
                <button class="search-btn" @click="getMsuAndServicerList()"><i class="icon iconfont icon-search"></i></button>
            </div>
        </div>
        <div class="column-layout">
            <div v-if="checkBox" class="table-layout">
                <el-table ref="mkuList" :data="servicerList" border style="width: 100%" @selection-change="handleSelectionChange">
                    <el-table-column v-if="checkBox" :selectable="selectable" type="selection" width="55"></el-table-column>
                    <el-table-column prop="name" label="服务商名称" align="center"></el-table-column>
                    <el-table-column prop="industryType.name" label="行业类型" align="center"></el-table-column>
                    <el-table-column prop="typeFlag" label="供应商类型" align="center"></el-table-column>
                    <el-table-column prop="staffCount" label="公司规模" align="center"></el-table-column>
                    <el-table-column label="注册资金(元)" align="center">
                        <template slot-scope="rows">
                            <div v-if="rows.row.registCapital != null">
                                <span>{{((rows.row.registCapital).toFixed(2)).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')}}</span>
                            </div>
                            <div v-else>
                                <span>0.00</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="table-layout" v-else>
                <el-table :data="servicerList" border style="width: 100%" highlight-current-row @current-change="handleCurrentChange">
                    <el-table-column width="55">

                        <template slot-scope="rows">
                            <div class="copy-radio" :class="{'circle' : checlServicerInfo!= null && checlServicerInfo.id == rows.row.id}">
                                <div class="circle-dot"></div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="服务商名称" align="center"></el-table-column>
                    <el-table-column prop="industryType.name" label="行业类型" align="center"></el-table-column>
                    <el-table-column prop="typeFlag" label="供应商类型" align="center"></el-table-column>
                    <el-table-column prop="staffCount" label="公司规模" align="center"></el-table-column>
                    <el-table-column label="注册资金(元)" align="center">
                        <template slot-scope="rows">
                            <div v-if="rows.row.registCapital != null">
                                <span>{{((rows.row.registCapital).toFixed(2)).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')}}</span>
                            </div>
                            <div v-else>
                                <span>0.00</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="block pagination-layout">
                <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'

    import servicerApi from '../../api/servicer'

    export default {
        name: 'swb-servicer-for-select',
        desc: '选择服务商',
        props: {
            checkBox: {
                type: Boolean,
                default: true
            },
            filter: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            servicerIds: {// 多选的时候传入
                type: Array,
                default: function () {
                    return [];
                }
            }
        },
        data: function () {
            return {
                //
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                servicerList: [],
                vendorTypeList: [],
                selectServicerList: [],
                checlServicerInfo: null,
                name: null
            }
        },
        created: function () {
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            //
            this.vendorTypeList = getEnumList("vendorType");
            this.getMsuAndServicerList();
        },
        methods: {
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getMsuAndServicerList();
            },
            getMsuAndServicerList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let filterItems = {};
                if(!Utils.isNoB(self.name)) {
                    filterItems.name = self.name;
                }
                postData.filterItems = filterItems;
                servicerApi.getServicerList(postData, function (result) {
                    if(result.type == "info") {
                        let servicerList = result.data.rows;
                        let vendorTypeList = getEnumList("vendorType");
                        let servicers = [];
                        for(let i = 0; i < servicerList.length; i++) {
                            let servicer = servicerList[i];
                            for(let i = 0; i < self.vendorTypeList.length; i++) {
                                let vendorTypes = vendorTypeList[i];
                                let vendorType = vendorTypes.value;
                                if(servicer.typeFlag == vendorType) {
                                    servicer.typeFlag = vendorTypes.text;
                                    servicers.push(servicer);
                                }
                            }

                        }
                        self.servicerList = servicers;
                        /* self.servicerList = result.data.rows;*/
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            selectable: function (row, index) {
                let selectIds = this.servicerIds;
                if(selectIds.indexOf(row.id) >= 0) {
                    return false;
                } else {
                    return true;
                }
            },
            handleSelectionChange: function (val) {
                this.selectServicerList = val;
            },
            handleCurrentChange: function (val) {
                this.checlServicerInfo = Utils.merge({}, val);
            },
            getServicerInfo: function (servicer) {
                let servicerInfo = {};
                if(servicer != null) {
                    servicerInfo.id = servicer.id;
                    servicerInfo.name = servicer.name;
                }
                return servicerInfo;
            },
            getServicerList: function () {
                let servicerList = [];
                let selectservicerList = this.selectServicerList;
                if(selectservicerList != null && selectservicerList.length > 0) {
                    for(var i = 0; i < selectservicerList.length; i++) {
                        let servicer = selectservicerList[i];
                        let servicerInfo = this.getServicerInfo(servicer);
                        servicerList.push(servicerInfo);
                    }
                }
                return servicerList;
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                //
                let checkBox = self.checkBox;
                if(checkBox) {
                    let servicerList = self.selectServicerList;
                    if(servicerList != null && servicerList.length > 0) {
                        result.type = "info";
                        result.data = self.getServicerList(servicerList);
                    } else {
                        result.type = 'warn';
                        result.message = '至少选择一个服务商！';
                    }
                } else {
                    let servicerInfo = self.checlServicerInfo;
                    if(servicerInfo != null) {
                        result.type = "info";
                        result.data = self.getServicerInfo(servicerInfo);
                    } else {
                        result.type = 'warn';
                        result.message = '请选择一个服务商！';
                    }
                }
                return result;
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/servicer/ServicerForSelect.vue